import LinkBanner from './link-banner';

export default LinkBanner;
